(function () {
  const STORAGE_KEY = 'tdfw_wishlist';


  /* =========================
     GET WISHLIST
  ========================= */

  function getWishlist() {
    try {
      const data = JSON.parse(
        localStorage.getItem(STORAGE_KEY)
      );

      return Array.isArray(data) ? data : [];
    } catch (error) {
      return [];
    }
  }


  /* =========================
     SAVE WISHLIST
  ========================= */

  function saveWishlist(items) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(items)
    );

    updateWishlistUI();
  }


  /* =========================
     CHECK PRODUCT
  ========================= */

  function isInWishlist(handle) {
    return getWishlist().some(
      item => item.handle === handle
    );
  }


  /* =========================
     ADD PRODUCT
  ========================= */

  function addProduct(product) {
    const wishlist = getWishlist();

    if (
      !wishlist.some(
        item => item.handle === product.handle
      )
    ) {

      wishlist.push(product);

      saveWishlist(wishlist);
    }
  }


  /* =========================
     REMOVE PRODUCT
  ========================= */

  function removeProduct(handle) {

    const wishlist = getWishlist().filter(
      item => item.handle !== handle
    );

    saveWishlist(wishlist);
  }


  /* =========================
     TOGGLE PRODUCT
  ========================= */

  function toggleProduct(product) {

    if (isInWishlist(product.handle)) {
      removeProduct(product.handle);
    } else {
      addProduct(product);
    }
  }


  /* =========================
     ESCAPE HTML
  ========================= */

  function escapeHTML(value) {

    const div = document.createElement('div');

    div.textContent = value || '';

    return div.innerHTML;
  }


  /* =========================
     RENDER WISHLIST PAGE
  ========================= */

  function renderWishlistPage() {

    const grid =
      document.querySelector(
        '[data-wishlist-grid]'
      );

    const empty =
      document.querySelector(
        '[data-wishlist-empty]'
      );


    // Not on wishlist page
    if (!grid || !empty) {
      return;
    }


    const wishlist = getWishlist();


    /* EMPTY WISHLIST */

    if (wishlist.length === 0) {

      grid.innerHTML = '';

      empty.hidden = false;

      return;
    }


    empty.hidden = true;


    /* BUILD PRODUCT CARDS */

    grid.innerHTML = wishlist
      .map(item => {

        const handle =
          escapeHTML(item.handle);

        const title =
          escapeHTML(item.title);

        const price =
          escapeHTML(item.price);

        const image =
          escapeHTML(item.image);

        const url =
          escapeHTML(item.url);


        return `

          <div
            class="wishlist-item"
            data-wishlist-item
          >

            <div class="wishlist-item__image-wrapper">

              <a
                href="${url}"
                class="wishlist-item__image-link"
              >

                ${
                  image
                    ? `
                      <img
                        src="${image}"
                        alt="${title}"
                        class="wishlist-item__image"
                        loading="lazy"
                      >
                    `
                    : ''
                }

              </a>


              <button
                type="button"
                class="wishlist-item__heart"
                data-wishlist-remove="${handle}"
                aria-label="Verwijderen uit favorieten"
              >
                ♥
              </button>

            </div>


            <div class="wishlist-item__details">

              <h2 class="wishlist-item__title">

                <a href="${url}">
                  ${title}
                </a>

              </h2>


              <div class="wishlist-item__price">
                ${price}
              </div>


              <a
                href="${url}"
                class="wishlist-item__view"
              >
                Bekijk fiets
              </a>


              <button
                type="button"
                class="wishlist-item__remove"
                data-wishlist-remove="${handle}"
              >
                Verwijderen uit favorieten
              </button>

            </div>

          </div>

        `;

      })
      .join('');
  }


  /* =========================
     UPDATE ALL WISHLIST UI
  ========================= */

  function updateWishlistUI() {

    const wishlist = getWishlist();


    /* HEADER COUNTER */

    document
      .querySelectorAll(
        '[data-wishlist-count]'
      )
      .forEach(counter => {

        counter.textContent =
          wishlist.length;

        counter.hidden =
          wishlist.length === 0;

      });


    /* PRODUCT BUTTONS */

    document
      .querySelectorAll(
        '[data-wishlist-button]'
      )
      .forEach(button => {

        const handle =
          button.dataset.productHandle;

        if (!handle) return;


        const active =
          isInWishlist(handle);


        button.classList.toggle(
          'wishlist-active',
          active
        );


        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );


        const icon =
          button.querySelector(
            '[data-wishlist-icon]'
          );


        const text =
          button.querySelector(
            '[data-wishlist-text]'
          );


        if (icon) {
          icon.innerHTML =
            active ? '♥' : '♡';
        }


        if (text) {

          text.textContent =
            active
              ? 'Toegevoegd aan favorieten'
              : 'Toevoegen aan favorieten';

        }

      });


    /* WISHLIST PAGE */

    renderWishlistPage();


    document.dispatchEvent(
      new CustomEvent(
        'wishlist:updated',
        {
          detail: {
            wishlist: wishlist
          }
        }
      )
    );
  }


  /* =========================
     ADD / TOGGLE PRODUCT
  ========================= */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-wishlist-button]'
        );


      if (!button) return;


      event.preventDefault();

      event.stopPropagation();


      const product = {

        handle:
          button.dataset.productHandle,

        title:
          button.dataset.productTitle || '',

        url:
          button.dataset.productUrl || '',

        image:
          button.dataset.productImage || '',

        price:
          button.dataset.productPrice || ''

      };


      if (!product.handle) return;


      toggleProduct(product);
    }
  );


  /* =========================
     REMOVE FROM WISHLIST PAGE
  ========================= */

  document.addEventListener(
    'click',
    function (event) {

      const removeButton =
        event.target.closest(
          '[data-wishlist-remove]'
        );


      if (!removeButton) return;


      event.preventDefault();


      const handle =
        removeButton.dataset.wishlistRemove;


      if (!handle) return;


      removeProduct(handle);
    }
  );


  /* =========================
     INITIAL LOAD
  ========================= */

  document.addEventListener(
    'DOMContentLoaded',
    updateWishlistUI
  );


  /* =========================
     PUBLIC API
  ========================= */

  window.TDFWWishlist = {

    get: getWishlist,

    add: addProduct,

    remove: removeProduct,

    toggle: toggleProduct,

    contains: isInWishlist,

    refresh: updateWishlistUI

  };

})();